<template>
    <div class="container">
        <div v-if="isAuthenticated">
            <h1 class="page-header">Mina organisationer</h1>
            <div class="intro">
                Här kan du registrera din organisation och teckna personuppgiftsbiträdesavtal, PUB-avtal.
                Du behöver teckna PUB-avtal om din organisation ska köpa licens till SPSM:s digitala läromedel och andra lärverktyg, Digitala samlingen.
                <br>
                <br>
                Om du vill registrera förvaltningar inom organisationen behöver du kontakta SPSM.
            </div>
            <TableOrganisations :items="organisations" />
            <div class="buttons-container push-buttons-right">
                <router-link class="btn btn-light" to="/registrering-intro">
                    Registrera organisation &nbsp;<span class="fas fa-plus"></span>
                </router-link>
            </div>
        </div>
        <div v-else>
            <h1 class="page-header">Mina organisationer</h1>
            <div class="intro">
                Här kan du registrera din organisation och teckna personuppgiftsbiträdesavtal, PUB-avtal.
                Du behöver teckna PUB-avtal om din organisation ska köpa licens till SPSM:s digitala läromedel och andra lärverktyg, Digitala samlingen.
                <br>
                <br>
                Det är viktigt att det är du som ska vara huvudkontakt för organisationen som gör registreringen.
                När registreringen är godkänd kan du utse fler organisationsadministratörer för din organisation.
                <br>
                <br>
                För att göra registreringen behöver du ha ett konto hos SPSM och logga in med BankId. Om du inte redan har ett SPSM-konto kommer du få möjlighet att skapa ett vid inloggningen.
            </div>
            <a class="btn btn-light" href="/login">Logga in &nbsp;<span class="fas fa-chevron-right"></span></a>
        </div>
    </div>
  <div class="container mt-5">
    <Accordion />
  </div>
</template>

<script lang="ts">
import { PropType, defineComponent } from "vue";
import Accordion from "../components/Accordion.vue";
import TableOrganisations from "../components/TableOrganisations.vue";
import { useOrganisationStore } from "@/stores/organisation";
import { useUserStore } from "@/stores/user";
import { storeToRefs } from "pinia";
import { StartViewModel } from '@Shared/Models/StartViewModel';

export default defineComponent({
  name: "Start",
  props:{ settings: Object as PropType<StartViewModel> },
  components: {
    Accordion,
    TableOrganisations
  },
  setup(props) {
    const organisationStore = useOrganisationStore();
    const userStore = useUserStore();

    const { isAuthenticated } = storeToRefs(userStore);
    const { organisations } = storeToRefs(organisationStore);

    return {
      isAuthenticated,
      organisations,
      settings: props.settings
    };
  }
});
</script>

<style lang="scss" scoped>
</style>